import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogDataService } from '../../../../dialog/dialog-data.service';
import { CourseDialogData } from '../../../../roster/roster.types';
import { CourseListInstructor } from '../../../../shared/interface/course.interface';
import { CourseListRegistrarInstructorService } from './course-list-registrar-instructor.service';

@Component({
    selector: 'app-course-list-registrar-instructor',
    templateUrl: './course-list-registrar-instructor.component.html',
    styleUrls: ['./course-list-registrar-instructor.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class CourseListRegistrarInstructorComponent implements OnInit {
    loading: boolean = true;
    instructors: Array<CourseListInstructor> = [];

    constructor(
        private dataService: DialogDataService<CourseDialogData>,
        private service: CourseListRegistrarInstructorService
    ) {
        this.loadInstructors();
    }

    ngOnInit(): void {}

    private loadInstructors(refreshCache: boolean = false) {
        this.loading = true;
        this.service
            .indexPromise({
                crn: this.dataService.data.crn,
                termCode: this.dataService.data.termCode,
                refreshCache: refreshCache
            })
            .then((instructorList: Array<CourseListInstructor>) => {
                this.loading = false;
                this.instructors = instructorList;
            })
            .catch(() => {
                this.loading = false;
            });
    }

    refreshInstructors() {
        this.loadInstructors(true);
    }
}
